import { render, staticRenderFns } from "./MenuSample.vue?vue&type=template&id=3c63ce47&scoped=true&"
import script from "./MenuSample.vue?vue&type=script&lang=js&"
export * from "./MenuSample.vue?vue&type=script&lang=js&"
import style0 from "./MenuSample.vue?vue&type=style&index=0&id=3c63ce47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63ce47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VIcon,VList,VListItem,VListItemTitle,VRow})
